const CHUNK_RELOAD_KEY = 'chunk-load-error-reloaded';

export function isChunkLoadError(reason: unknown): boolean {
  if (!reason) return false;

  if (typeof reason === 'string') {
    return (
      reason.includes('ChunkLoadError') ||
      reason.includes('Loading chunk') ||
      reason.includes('loading chunk') ||
      /Failed to fetch dynamically imported module/i.test(reason)
    );
  }

  const anyReason = reason as { name?: string; message?: string };
  const name = anyReason?.name ?? '';
  const message = anyReason?.message ?? '';

  return (
    name === 'ChunkLoadError' ||
    name.includes('ChunkLoadError') ||
    /Loading chunk .+ failed/i.test(message) ||
    message.includes('ChunkLoadError') ||
    message.includes('pending timeout') ||
    /Failed to fetch dynamically imported module/i.test(message)
  );
}

/** Reload once per session when a stale chunk is detected. Returns true if reload was triggered. */
export function reloadOnceForChunkError(): boolean {
  if (typeof window === 'undefined') return false;

  const hasReloaded = sessionStorage.getItem(CHUNK_RELOAD_KEY);
  if (hasReloaded) return false;

  sessionStorage.setItem(CHUNK_RELOAD_KEY, 'true');
  window.location.reload();
  return true;
}

export function clearChunkReloadFlag(): void {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(CHUNK_RELOAD_KEY);
}
